import { combineReducers } from 'redux';
import { combineEpics } from 'redux-observable';

import { _reducer as acceleratedTesters } from './acceleratedTesters.reducers';
import acceleratedTestersEpics from './acceleratedTesters.epics';

export const reducer = combineReducers({
  acceleratedTesters,
});

export const epics = combineEpics(acceleratedTestersEpics);

export * from './acceleratedTesters.actions';
export * from './acceleratedTesters.selectors';
